import useApi from '../../../services/useApi'
import moment from 'moment'
import useFilters from '../../../hook/useFilters'

export const useGetDateDetails = (selectedDate: any,store:any,supplier:any) => {
  const Api = useApi()

  const initialFilters = {
    date: selectedDate ? moment(selectedDate).format('YYYY-MM-DD') : '',
    sort_by: 'po_date/1',
    store_filter: store,
    supplier_filter: supplier,
  }

  const {filters, onSortingChange} = useFilters(initialFilters, {
    sortType: 'number',
  })

  const {data: response, isFetching} = Api.useGetQuery(`/analytics/zoho/payment/details`, {
    filters: filters,
    queryId: `payment-details-${selectedDate}`,
  })

  return {
    selectedDate,
    selectedDateDetails: response?.data || [],
    isLoadingDateDetails: isFetching,
    filters,
    onSortingChange,
  }
}
